module.exports = __webpack_public_path__ + "img/logo_sgs.1a0be588.jpg";